import {DataSourceItem} from '../../store/ast/ast.types';
import {RenderDataSource} from '../../store/data/data.types';


/**
 * 构建单个数据源的过滤器
 * @param dataSource 当前数据源
 * @param renderDataSources
 * @param attrObject
 * @returns 构建好的过滤器
 */
export function buildFilter(
    dataSource: DataSourceItem,
    renderDataSources: Map<string, RenderDataSource>,
    attrObject: object
): any {
    dataSource.filter = dataSource.filter || [];
    if (attrObject) {
        dataSource.filter.forEach((data) => {
            if (attrObject[data.prop]) {
                data.value = attrObject[data.prop]
                data.realVal = attrObject[data.prop]
                data.valueType = "FIXED"
            }
        })
    }
    if (!attrObject) {
        for (let i = 0; i < dataSource.filter.length; i++) {
            const item = dataSource.filter[i];
            if (item.valueType === "DYNAMIC") {
                // 动态值需要从父数据源获取
                let sourceProp = item.sourceProp;
                const parentData = renderDataSources.get(sourceProp);
                const data = _get(parentData, "items[0].data"); // 取第一条数据
                if (data && data[item.value] !== undefined) {
                    item.realVal = data[item.value];
                }
            }
        }
    }

    // 数据源DAG配置关系中where 条件的配置 配置了空值时不可查询时 需要排出这个条件不作为过滤条件 (从后往前遍历，避免删除元素后索引混乱)
    for (let i = dataSource.filter.length - 1; i >= 0; i--) {
      const data = dataSource.filter[i];
      if ((!data.realVal && data.nullCheck) && data.valueType !== "FIXED") {
        dataSource.filter.splice(i, 1);
      }
    }

    if (dataSource.type == "function" && attrObject && dataSource.filter.length == 0){
      dataSource.filter = {data:attrObject}
    }
    return dataSource.filter
}

